<template>
  <div>
    <el-table :data="auditList" height="calc(100vh - 360px)">
      <el-table-column label="租户" prop="tenantName" fixed="left" />
      <el-table-column prop="userId" label="用户Id" width="100" fixed="left">
        <template slot-scope="scope">
          <span v-if="scope.row.mark" class="red">{{ scope.row.userId }}</span>
          <span v-else>{{ scope.row.userId }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="topUserId"
        label="合伙人UID"
        width="100"
        fixed="left"
      ></el-table-column>
      <el-table-column prop="id" label="订单id" min-width="190" fixed="left">
        <template slot-scope="scope">
          <span v-if="scope.row.mark" class="red">{{ scope.row.id }}</span>
          <span v-else>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="externalId"
        label="外部订单id"
        min-width="190"
        fixed="left"
      ></el-table-column>
      <el-table-column prop="coinType" label="币种"></el-table-column>
      <el-table-column prop="currencyCoin" label="法币"></el-table-column>
      <el-table-column prop="" label="下单方向">
        <template slot-scope="scope">
          {{ scope.row.orderSide == 1 ? '买' : '卖' }}
        </template>
      </el-table-column>
      <el-table-column prop="price" label="下单价格"></el-table-column>
      <el-table-column prop="unitPrice" label="实际价格"></el-table-column>
      <el-table-column prop="" label="下单币种数量" width="120">
        <template slot-scope="scope">
          <span> {{ scope.row.coinAmount }}</span>
          <span v-if="scope.row.coinAmount">
            {{ scope.row.coinType }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="下单法币数量" width="120">
        <template slot-scope="scope">
          {{ scope.row.amount }}{{ scope.row.currencyCoin }}
        </template>
      </el-table-column>
      <el-table-column prop="" label="实际到账代币数量" width="140">
        <template slot-scope="scope">
          <span> {{ scope.row.successCoinAmount }}</span>
          <span v-if="scope.row.successCoinAmount">
            {{ scope.row.coinType }}</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="" label="实际法币到账数据" width="140">
        <template slot-scope="scope">
          <span> {{ scope.row.successAmount }}</span>
          <span v-if="scope.row.successAmount">{{
            scope.row.currencyCoin
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="channel"
        label="支付服务商"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="linkUrl"
        label="支付链接"
        :show-overflow-tooltip="true"
        width="150"
      >
        <template slot-scope="scope">
          <a :href="scope.row.linkUrl" target="_blank" class="network-link">
            {{ scope.row.linkUrl }}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag type="danger" v-if="scope.row.status == 0">失败</el-tag>
          <el-tag type="success" v-if="scope.row.status == 1">成功</el-tag>
          <el-tag v-if="scope.row.status == -1">进行中</el-tag>
          <el-tag type="warning" v-if="scope.row.status == -2">审核中</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" width="120"></el-table-column>
      <el-table-column label="创建时间" width="200">
        <template slot-scope="scope">{{
          scope.row.createTime | moment
        }}</template>
      </el-table-column>
      <el-table-column label="修改时间" width="200">
        <template slot-scope="scope">{{
          scope.row.updateTime | moment
        }}</template>
      </el-table-column>
      <el-table-column label="是否异常账户">
        <template slot-scope="scope">
          <el-tag type="danger" v-if="scope.row.mark === true">是</el-tag>
          <el-tag type="success" v-else>否</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="handleCurrentChange"
    ></pagination>
  </div>
</template>

<script>
import Pagination from 'components/pagination'
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex'

export default {
  name: 'KYCAudit',
  data() {
    return {
      auditId: null,
    }
  },
  computed: {
    ...mapState('otcDeposite', ['pagination', 'totalCount', 'auditList']),
  },
  components: {
    Pagination,
  },
  methods: {
    ...mapMutations('otcDeposite', ['setpage']),
    handleCurrentChange(pagination) {
      console.log('page', pagination)
      this.setpage(pagination)
      this.$emit('refresh', { ...pagination })
    },
  },
}
</script>

<style lang="less" scoped>
.red {
  color: red;
  font-weight: bold;
}
</style>
